import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { MoondanceContext } from "../../App";

// Menu shown from the topbar hamburger (replaces the old vertical sidebar).
const VIEWS = [
  { label: "KPIs", icon: "mdi mdi-desktop-mac-dashboard", url: "/dashboard/summary" },
  { label: "Positions", icon: "fas fa-chess", url: "/dashboard/positions" },
  { label: "Cash Flows", icon: "fas fa-money-check-alt", url: "/dashboard/cashflows" },
  { label: "Transactions", icon: "mdi mdi-cash-multiple", url: "/dashboard/transactions" },
  { label: "Budget", icon: "fas fa-piggy-bank", url: "/dashboard/budget" },
  { label: "Charts", icon: "mdi mdi-chart-areaspline", url: "/dashboard/charts" },
  { label: "Table", icon: "mdi mdi-table", url: "/dashboard/table" },
  { label: "Notes", icon: "bx bx-notepad", url: "/dashboard/notes" },
  { label: "Files", icon: "mdi mdi-file", url: "/dashboard/files" },
];

const ACTIONS = [
  { label: "Add Transaction", icon: "mdi mdi-cash", url: "/addTransaction" },
  { label: "Update NAV", icon: "mdi mdi-gold", url: "/addNav" },
  { label: "Add Position", icon: "mdi mdi-bank-plus", url: "/addPosition" },
  { label: "Group Nav Update", icon: "mdi mdi-gold", url: "/navbulk" },
  { label: "Generate Report", icon: "mdi mdi-printer", url: "/report" },
  { label: "Import your Data", icon: "mdi mdi-file-import", url: "/importXls" },
  { label: "Export your Data", icon: "mdi mdi-file-excel", url: "/export" },
  { label: "Add File", icon: "mdi mdi-file", url: "/addFile" },
];

export default function MenuDropdown() {
  const { darkMode, selectedAccountList } = useContext(MoondanceContext);
  const [open, setOpen] = useState(false);
  const hasAccounts = selectedAccountList && selectedAccountList.length > 0;

  const renderItem = (item) => (
    <Link
      key={item.url}
      to={item.url}
      className="dropdown-item d-flex align-items-center"
      onClick={() => setOpen(false)}
    >
      <i className={item.icon} style={{ marginRight: "10px", minWidth: "1.2em", textAlign: "center" }}></i>
      <span>{item.label}</span>
    </Link>
  );

  return (
    <Dropdown
      isOpen={open}
      toggle={() => setOpen(!open)}
      // Hamburger lives at the left of the topbar; the menu opens downward.
      className="d-inline-block"
    >
      <DropdownToggle
        tag="button"
        type="button"
        title="Menu"
        id="vertical-menu-btn"
        className="btn header-item"
        style={{
          border: "none",
          background: "transparent",
          color: "#e9ecef",
          fontSize: "22px",
          cursor: "pointer",
        }}
      >
        <i className="ri-menu-2-line align-middle"></i>
      </DropdownToggle>
      <DropdownMenu
        className="app-dark-dropdown"
        style={{ maxHeight: "80vh", overflowY: "auto", minWidth: "15em", maxWidth: "90vw" }}
      >
        {hasAccounts ? (
          <>
            <h6 className="dropdown-header">Views</h6>
            {VIEWS.map(renderItem)}
            <div className="dropdown-divider"></div>
            <h6 className="dropdown-header">Actions</h6>
            {ACTIONS.map(renderItem)}
          </>
        ) : (
          <span className="dropdown-item-text text-muted">No account selected</span>
        )}
      </DropdownMenu>
    </Dropdown>
  );
}
